<template>
    <div class="info-board-container">
        <Title>{{ tower.title }}</Title>
        <div class="info-board">
            <p class="text" v-html="tower.text"></p>
            <div>
                <a-tag v-for="tag of tags" :key="tag">{{ tag }}</a-tag>
            </div>
            <div class="opts">
                [<a :href="link" target="_blank">开始游戏</a>]
                [<a :href="`${link}${tower.name}.zip`" target="_blank">下载游戏</a>]
                [<a :href="`${link}editor.html`" target="_blank">打开工程</a>]
            </div>
        </div>
    </div>
</template>

<script>
import Title from '@/components/Title.vue'

export default {
    props: {
        tower: Object
    },
    computed: {
        tags() {
            const tags = this.tower.tag.split("|");
            if (tags[tags.length-1] == "") tags.pop();
            return tags;
        },
        link() {
            return this.tower.link;
        }
    },
    components: {
        Title,
    }
}
</script>

<style lang="less" scoped>
.info-board-container {
    text-align: left;
}
.info-board {
    margin-left: 10px;
}
.opts {
    margin-top: 10px;
}
.text {
    font-size: 16px;
}
</style>